module.exports = __webpack_public_path__ + "img/ozo_nav_icon.dea1c365.svg";